import React, { useEffect, Fragment, useState, useMemo } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import PurchaseOrderActions from '@Actions/purchaseOrderActions';
import TenantActions from '@Actions/tenantActions';
import { faAnglesRight, faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Table, Select, Tooltip, Popconfirm, Checkbox, Dropdown, Tag, Popover, Radio, Space, DatePicker, Modal, Spin, Drawer,
  Divider,
  Menu,
} from 'antd';
import SubMenu from 'antd/es/menu/SubMenu.js';
import {
  ControlOutlined, CopyOutlined, ExclamationCircleOutlined, FilterOutlined,
} from '@ant-design/icons';
import Constants, { toISTDate } from '@Apis/constants';
import ZohoBooks from '@Images/admin/integrations/zoho-books.png';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import Helpers from '@Apis/helpers';
import searchIcon from '@Images/icons/icon-search.png';
import H3Text from '@Uilib/h3Text';
import GRNActions from '@Actions/grnActions';
import ZohoIntegrationActions from '@Actions/integrations/zohoIntegrationActions';
import H3Image from '@Uilib/h3Image';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import CFV2Actions from '@Actions/configurations/cfV2Actions';
import ViewTableCustomFields from '@Components/Common/CustomField/ViewTableCustomFields';
import H3DateSelector from '@Uilib/h3DateSelector';
import ProductActions from '@Actions/productActions';
import TagSelector from '@Components/Common/Selector/TagSelector';
import closeIcon from '@Images/icons/icon-close-blue.png';
import SelectDepartment from '@Components/Common/SelectDepartment';
import { v4 as uuidv4 } from 'uuid';
import AnalyticsActions from '@Actions/application/analyticsActions';
import HideValue from '../../../../Common/RestrictedAccess/HideValue';
import BulkImportPO from './BulkImportPO';
import PRZText from '../../../../Common/UI/PRZText';
import MoreInfoMobileView from '../../../../Common/MoreInfoMobileView';
import { ListScreenKeys } from './mobileListHelper';
import useCheckPortrait from '../../../../../hooks/useCheckPortrait';
import PRZSelect from '../../../../Common/UI/PRZSelect/index.jsx';
import { GetPurchaseOrders } from '@Modules/purchase/purchaseOrder';
import { dateRangePresets, dateRangePresetsValues, entityNameEnum, filterTypeEnums } from '../../../../../apis/constants.js';
import UserSavedFilterViewSelector from '../../../../Common/UserSavedFilterViewSelector/index.jsx';
import './style.scss';

const { Option } = Select;
const receivedStatus = ['RECEIVED', 'PARTIALLY_RECEIVED', 'NOT_RECEIVED', 'RECEIVED_MORE'];
const timePeriods = [
  {
    id: 1,
    label: 'All Purchase Orders',
    value: ['', ''].toString(),
  },
  {
    id: 2,
    label: 'Expired',
    value: ['', dayjs(dayjs().utc().startOf('day').valueOf()).valueOf()].toString(),
  },
  {
    id: 7,
    label: 'Not Expired',
    value: [dayjs(dayjs().utc().startOf('day').valueOf()).valueOf(),
    dayjs(dayjs('2099-01-01').utc().endOf('day').valueOf()).valueOf()].toString(),
  },
  {
    id: 3,
    label: 'Expires Today',
    value: [dayjs(dayjs().utc().startOf('day').valueOf()).valueOf(), dayjs(dayjs().utc().endOf('day').valueOf()).valueOf()].toString(),
  },
  {
    id: 4,

    label: 'Expires Tomorrow',
    value: [dayjs(dayjs().utc().add(1, 'days').startOf('day')
      .valueOf()).valueOf(), dayjs(dayjs().utc().add(1, 'days').endOf('day')
        .valueOf()).valueOf()].toString(),
  },
  {
    id: 5,

    label: 'Expires This Week',
    value: [dayjs(dayjs().utc().startOf('week').valueOf()).valueOf(),
    dayjs(dayjs().utc().endOf('week').valueOf()).valueOf()].toString(),
  },
  {
    id: 6,
    label: 'Expires Next Week',
    value: [dayjs(dayjs().utc().add(1, 'week').startOf('week')
      .valueOf()).valueOf(),
    dayjs(dayjs().utc().add(1, 'week').endOf('week')
      .valueOf()).valueOf()].toString(),
  },

];
const timePeriodOptions = timePeriods?.map((timePeriod) => ({
  key: timePeriod.id,
  value: timePeriod.value,
  label: timePeriod.label,
}));

/**
 * @param status
 */
function PurchaseOrdersList({
  user, history, getProductsLoading, getDocCFV2Loading, syncPOLoading, getPurchaseOrdersV2Loading, customFieldsProps, getPurchaseOrdersV2,
  syncPO, getDocCFV2, getDocCFV2Success, getDownloadPOLoading, downloadPOData, MONEY, products, getProducts,
  departments, priceMasking, downloadDocument, purchaseOrdersV2,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [selectedTenant, setSelectedTenant] = useState('');
  const [destinationTenantId, setDestinationTenantId] = useState([]);
  const [isUserReady, setIsUserReady] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState('');
  const [selectedReceivingStatus, setSelectedReceivingStatus] = useState([]);
  const [paymentStatus, setPaymentStatus] = useState('');
  const [estimatedDeliveryDate, setEstimatedDeliveryDate] = useState('');
  const [expiryStartDate, setExpiryStartDate] = useState('');
  const [expiryTime, setExpiryTime] = useState('');
  const [expiryEndDate, setExpiryEndDate] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [openPopover, setOpenPopover] = useState(false);
  const [reportType, setReportType] = useState('document_level');
  const [fixedColumns, setFixedColumns] = useState(['PO_NUMBER']);
  const [searchByProduct, setSearchByProduct] = useState('');
  const [selectedProductId, setSelectedProductId] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedTag, setSelectedTag] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState([]);
  const [selectedProductFromPR, setSelectedProductFromPR] = useState([]);
  const [selectedPO, setSelectedPO] = useState(null);
  const [moreDetailsDrawer, setMoreDetailsDrawer] = useState(false);
  const [call, setCall] = useState(false);
  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();

  const [visibleColumns, setVisibleColumns] = useState(localStorage.getItem('prcz-page-columns-po') ? JSON.parse(localStorage.getItem('prcz-page-columns-po')) : {
    PO_NUMBER: {
      label: 'Purchase Order#',
      visible: true,
    },
    LOCATION: {
      label: 'Location',
      visible: true,
    },
    PO_TYPE: {
      label: 'PO Type',
      visible: true,
    },
    VENDOR: {
      label: 'Vendor',
      visible: true,
    },
    ITEMS: {
      label: 'Items',
      visible: true,
    },
    AMOUNT_WITHOUT_TAX: {
      label: 'Amount (Without Tax)',
      visible: false,
    },
    TAXES: {
      label: 'Taxes',
      visible: false,
    },
    AMOUNT_WITH_TAX: {
      label: 'Total Amount',
      visible: true,
    },
    CREATED_DATE: {
      label: 'Created Date',
      visible: true,
    },
    PO_DATE: {
      label: 'Order Date',
      visible: false,
    },
    PAYMENT_TERMS: {
      label: 'Payment Terms',
      visible: false,
    },
    STATUS: {
      label: 'Status',
      visible: true,
    },
    EXPIRY_STATUS: {
      label: 'Expiry Status',
      visible: true,
    },
    RECEIVING_STATUS: {
      label: 'Receiving Status',
      visible: true,
    },
    PAYMENT_STATUS: {
      label: 'Payment Status',
      visible: true,
    },
    MRP_NUMBER: {
      label: 'Linked MRP',
      visible: true,
    },
    LINKED_PR: {
      label: 'Linked Material Requests',
      visible: true,
    },
    ATTACHMENTS: {
      label: 'Attachments',
      visible: true,
    },
    LABEL: {
      label: 'Label',
      visible: true,
    },
  });
  const [showBulkImportDrawer, setShowBulkImportDrawer] = useState(false);

  const [currentDefaultView, setCurrentDefaultView] = useState({});
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState([]);
  const [selectedFilterView, setSelectedFilterView] = useState({});
  const [isUserReadyInitial, setIsUserReadyInitial] = useState(false);
  const [isUpdateFilterSate, setIsUpdateFilterSate] = useState(true);
  const [savedFilterViews, setSavedFilterViews] = useState([]);
  const [savedFilterViewsLoading, setSavedFilterViewsLoading] = useState(false);

  const [orderDateSelectedIntervalDateRangeType, setOrderDateSelectedIntervalDateRangeType] = useState('');

  const colorArray = ['blue', 'red', 'geekblue', 'green', 'volcano', 'orange', 'cyan', 'purple', 'blue', 'red', 'geekblue', 'green', 'volcano', 'orange', 'cyan', 'purple'];

  const pushParamsToUrl = (page, lmt, currentTenant, status, poReceivingStatus, word, expStartDate, expEndDate, expTimeRange, start, end, paymentStatusValue, edd, productSearch, tags, departmentIds, selectedProductFromPR, destinationTenantIdParams, orderDateSelectedIntervalDateRangeType, selectedFilterView) => {
    let url = '';
    if (page) url += `?page=${page}`;
    if (lmt) url += `&limit=${lmt}`;
    if (currentTenant.length > 0) url += `&tenant=${currentTenant}`;
    if (destinationTenantIdParams.length > 0) url += `&destination_tenant_id=${destinationTenantIdParams}`;
    if (status) url += `&status=${status}`;
    if (word) url += `&keyword=${word}`;
    if (poReceivingStatus.length > 0) url += `&po_receiving_status=${poReceivingStatus}`;
    if (expStartDate) url += `&expiry_start_date=${expStartDate}`;
    if (expEndDate) url += `&expiry_end_date=${expEndDate}`;
    if (expTimeRange) url += `&exp_time_range=${expTimeRange}`;
    if (paymentStatusValue) url += `&payment_status=${paymentStatusValue}`;
    if (start) url += `&startDate=${start}`;
    if (end) url += `&endDate=${end}`;
    if (orderDateSelectedIntervalDateRangeType) url += `&order_date_type=${orderDateSelectedIntervalDateRangeType}`;
    if (edd) url += `&edd=${edd}`;
    if (selectedProductFromPR.length > 0) url += `&product_search_from_pr=${selectedProductFromPR}`;
    if (productSearch) url += `&product_search=${productSearch}`;
    if (tags.length > 0) url += `&label=${tags}`;
    if (departmentIds.length > 0) url += `&department_ids=${departmentIds.join(',')}`;
    if (selectedFilterView) url += `&filter_id=${selectedFilterView?.filter_id}`;
    history.push(url);
  };

  function getFilterValueByKey({ filtersArray, key, valueOnly = true }) {
    const selectedFilter = filtersArray.find((item) => item.filter_key === key) || null;
    return valueOnly ? selectedFilter?.filter_value : selectedFilter;
  }

  function getAppliedFiltersFromURL() {
    const appliedFiltersFromURL = [
      {
        filter_key: 'limit',
        filter_value: Number(Helpers.getValueFromUrl('limit')) || limit,
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'tenant',
        filter_value: Helpers.getValueFromUrl('tenant')
          ? Helpers.getValueFromUrl('tenant')?.split(',')?.map(Number)
          : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'destination_tenant_id',
        filter_value: Helpers.getValueFromUrl('destination_tenant_id')
          ? Helpers.getValueFromUrl('destination_tenant_id')?.split(',')?.map(Number)
          : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'status',
        filter_value: Helpers.getValueFromUrl('status') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'keyword',
        filter_value: Helpers.getValueFromUrl('keyword') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'po_receiving_status',
        filter_value: Helpers.getValueFromUrl('po_receiving_status')
          ? Helpers.getValueFromUrl('po_receiving_status')?.split(',')
          : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'expiry_start_date',
        filter_value: (() => {
          const range = Helpers.getValueFromUrl('exp_time_range');
          if (range === 'Expired') return '';
          if (range === 'Expires Today') return dayjs().utc().startOf('day').valueOf();
          if (range === 'Expires Tomorrow') return dayjs().utc().add(1, 'days').startOf('day').valueOf();
          if (range === 'Expires This Week') return dayjs().utc().startOf('week').valueOf();
          if (range === 'Expires Next Week') return dayjs().utc().add(1, 'week').startOf('week').valueOf();
          if (range === 'Not Expired') return dayjs().utc().startOf('day').valueOf();
          return Number(Helpers.getValueFromUrl('expiry_start_date')) || '';
        })(),
        filter_type: filterTypeEnums.DATE,
      },
      {
        filter_key: 'expiry_end_date',
        filter_value: (() => {
          const range = Helpers.getValueFromUrl('exp_time_range');
          if (range === 'Expired') return dayjs().subtract(1, 'days').valueOf();
          if (range === 'Expires Today') return dayjs().utc().endOf('day').valueOf();
          if (range === 'Expires Tomorrow') return dayjs().utc().add(1, 'days').endOf('day').valueOf();
          if (range === 'Expires This Week') return dayjs().utc().endOf('week').valueOf();
          if (range === 'Expires Next Week') return dayjs().utc().add(1, 'week').endOf('week').valueOf();
          if (range === 'Not Expired') return dayjs('2099-01-01').utc().endOf('day').valueOf();
          return Number(Helpers.getValueFromUrl('expiry_end_date')) || '';
        })(),
        filter_type: filterTypeEnums.DATE,
      },
      {
        filter_key: 'exp_time_range',
        filter_value: Helpers.getValueFromUrl('exp_time_range') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'payment_status',
        filter_value: Helpers.getValueFromUrl('payment_status') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'startDate',
        filter_value: Number(Helpers.getValueFromUrl('startDate')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('order_date_type') || '',
      },
      {
        filter_key: 'endDate',
        filter_value: Number(Helpers.getValueFromUrl('endDate')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('order_date_type') || '',
      },
      {
        filter_key: 'edd',
        filter_value: Helpers.getValueFromUrl('edd') ? Helpers.getValueFromUrl('edd') : null,
        filter_type: filterTypeEnums.DATE,
      },
      {
        filter_key: 'product_search_from_pr',
        filter_value: Helpers.getValueFromUrl('product_search_from_pr')
          ? Helpers.getValueFromUrl('product_search_from_pr')?.split(',')
          : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      // {
      //   filter_key: 'product_search',
      //   filter_value: Helpers.getValueFromUrl('product_search')
      //     ? Helpers.getValueFromUrl('product_search')?.split(',')
      //     : [],
      //   filter_type: filterTypeEnums.ARRAY,
      // },
      {
        filter_key: 'label',
        filter_value: Helpers.getValueFromUrl('label')
          ? Helpers.getValueFromUrl('label')?.split(',')
          : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'department_ids',
        filter_value: Helpers.getValueFromUrl('department_ids')
          ? Helpers.getValueFromUrl('department_ids')?.split(',')?.map(Number)
          : [],
        filter_type: filterTypeEnums.ARRAY,
      },

    ];
    return appliedFiltersFromURL;
  }

  const initialFilterValues = useMemo(() => [
    {
      filter_key: 'limit',
      filter_value: limit,
      filter_type: filterTypeEnums.NUMBER,
    },
    {
      filter_key: 'tenant',
      filter_value: [user?.tenant_info?.tenant_id],
      filter_type: filterTypeEnums.ARRAY,
    },
    {
      filter_key: 'destination_tenant_id',
      filter_value: [],
      filter_type: filterTypeEnums.ARRAY,
    },
    {
      filter_key: 'status',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'keyword',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'po_receiving_status',
      filter_value: [],
      filter_type: filterTypeEnums.ARRAY,
    },
    {
      filter_key: 'expiry_start_date',
      filter_value: '',
      filter_type: filterTypeEnums.DATE,
    },
    {
      filter_key: 'expiry_end_date',
      filter_value: '',
      filter_type: filterTypeEnums.DATE,
    },
    {
      filter_key: 'exp_time_range',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'payment_status',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'startDate',
      filter_value: '',
      filter_type: filterTypeEnums.DATE_RANGE,
      date_range_type: '',
    },
    {
      filter_key: 'endDate',
      filter_value: '',
      filter_type: filterTypeEnums.DATE_RANGE,
      date_range_type: '',
    },
    {
      filter_key: 'edd',
      filter_value: null,
      filter_type: filterTypeEnums.DATE,
    },
    {
      filter_key: 'product_search_from_pr',
      filter_value: [],
      filter_type: filterTypeEnums.ARRAY,
    },
    // {
    //   filter_key: 'product_search',
    //   filter_value: [],
    //   filter_type: filterTypeEnums.ARRAY,
    // },
    {
      filter_key: 'label',
      filter_value: [],
      filter_type: filterTypeEnums.ARRAY,
    },
    {
      filter_key: 'department_ids',
      filter_value: [],
      filter_type: filterTypeEnums.ARRAY,
    },
  ], []);

  const systemDefaultUserView = useMemo(() => ({
    filter_id: 'system_default',
    filter_name: 'System Default View',
    entity_name: entityNameEnum.PURCHASE_ORDER,
    filters: initialFilterValues,
    tenant_id: user?.tenant_info?.tenant_id,
    org_id: user?.user_org_id,
    user_id: user?.user_id,
    is_default: false,
    is_system_default: true,
  }), []);

  useEffect(() => {
    // Start a timer with the debounce delay
    const handler = setTimeout(() => {
      if (searchByProduct) {
        getProducts(searchByProduct, user?.tenant_info?.tenant_id, '', 5, 1, '', '', '', '', '', '', '');
      }
    }, 500); // 500ms debounce time
    // Cleanup function to clear the timer
    return () => {
      clearTimeout(handler);
    };
  }, [searchByProduct]);

  useEffect(() => {
    if (user?.tenant_info?.org_id) {
      setSelectedFilterView(systemDefaultUserView);

      // setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
      // setLimit(Number(Helpers.getValueFromUrl('limit') || limit));
      // setSelectedTenant(Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (Number(item))) : [user?.tenant_info?.tenant_id]);
      // // setDestinationTenantId(Helpers.getValueFromUrl('destination_tenant_id') ? Helpers.getValueFromUrl('destination_tenant_id')?.split(',')?.map((item) => (Number(item))) : [user?.tenant_info?.tenant_id]);
      // setSelectedStatus(Helpers.getValueFromUrl('status'));
      // setPaymentStatus(Helpers.getValueFromUrl('payment_status'));
      // setSelectedReceivingStatus(Helpers.getValueFromUrl('po_receiving_status') ? Helpers.getValueFromUrl('po_receiving_status')?.split(',') : []);
      // setSearchKeyword(Helpers.getValueFromUrl('keyword'));
      // setKeyword(Helpers.getValueFromUrl('keyword'));
      // setStartDate(Number(Helpers.getValueFromUrl('startDate')));
      // setEndDate(Number(Helpers.getValueFromUrl('endDate')));
      // setSelectedEmails([user?.email]);
      // setExpiryTime(Helpers.getValueFromUrl('exp_time_range'));
      // setSelectedDepartment(Helpers.getValueFromUrl('department_ids') ? Helpers.getValueFromUrl('department_ids')?.split(',').map((item) => (Number(item))) : []);
      // setSelectedProductFromPR(Helpers.getValueFromUrl('product_search_from_pr') ? Helpers.getValueFromUrl('product_search_from_pr')?.split(',') : []);
      // setEstimatedDeliveryDate(Helpers.getValueFromUrl('edd') ? dayjs(Helpers.getValueFromUrl('edd')) : null);
      // setSelectedTag(Helpers.getValueFromUrl('label') ? Helpers.getValueFromUrl('label')?.split(',')?.map((item) => item) : []);
      // if (Helpers.getValueFromUrl('exp_time_range') === 'Expired') {
      //   setExpiryStartDate('');
      //   setExpiryEndDate(dayjs().subtract(1, 'days')?.valueOf());
      // } else if (Helpers.getValueFromUrl('exp_time_range') === 'Expires Today') {
      //   setExpiryStartDate(dayjs(dayjs().utc().startOf('day').valueOf()).valueOf());
      //   setExpiryEndDate(dayjs(dayjs().utc().endOf('day').valueOf()).valueOf());
      // } else if (Helpers.getValueFromUrl('exp_time_range') === 'Expires Tomorrow') {
      //   setExpiryStartDate(dayjs(dayjs().utc().add(1, 'days').startOf('day')
      //     .valueOf()).valueOf());
      //   setExpiryEndDate(dayjs(dayjs().utc().add(1, 'days').endOf('day')
      //     .valueOf()).valueOf());
      // } else if (Helpers.getValueFromUrl('exp_time_range') === 'Expires This Week') {
      //   setExpiryStartDate(dayjs(dayjs().utc().startOf('week').valueOf()).valueOf());
      //   setExpiryEndDate(dayjs(dayjs().utc().endOf('week').valueOf()).valueOf());
      // } else if (Helpers.getValueFromUrl('exp_time_range') === 'Expires Next Week') {
      //   setExpiryStartDate(dayjs(dayjs().utc().add(1, 'week').startOf('week')
      //     .valueOf()).valueOf());
      //   setExpiryEndDate(dayjs(dayjs().utc().add(1, 'week').endOf('week')
      //     .valueOf()).valueOf());
      // } else if (Helpers.getValueFromUrl('exp_time_range') === 'Not Expired') {
      //   setExpiryStartDate(dayjs(dayjs().utc().startOf('day').valueOf()).valueOf());
      //   setExpiryEndDate(dayjs(dayjs('2099-01-01').utc().endOf('day').valueOf()).valueOf());
      // } else {
      //   setExpiryStartDate(Number(Helpers.getValueFromUrl('expiry_start_date')));
      //   setExpiryEndDate(Number(Helpers.getValueFromUrl('expiry_end_date')));
      // }
      // setIsUserReady(true);
    }
    return () => {
      getDocCFV2Success(null);
    };
  }, []);

  useEffect(() => {
    if (savedFilterViews && isUserReadyInitial) {
      const defaultUserView = savedFilterViews.find((item) => item.is_default);

      if (defaultUserView) {
        setCurrentDefaultView(defaultUserView);
      } else {
        setCurrentDefaultView(systemDefaultUserView);
      }

      const appliedFiltersFromURL = getAppliedFiltersFromURL();

      const selectedFilterViewFromURL = Helpers.getValueFromUrl('filter_id');

      let currentSelectedView;
      if (selectedFilterViewFromURL) {
        currentSelectedView = savedFilterViews.find((item) => String(item.filter_id) === String(selectedFilterViewFromURL));
        if (!currentSelectedView) {
          currentSelectedView = systemDefaultUserView;
        }
      } else {
        currentSelectedView = defaultUserView || systemDefaultUserView;
      }

      const filterValues = (isFromURL) => {
        const currentSelectedViewFilters = currentSelectedView.filters;

        const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: filterKey }) }), {});

        const _orderDateRangeType = getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'startDate', valueOnly: false }).date_range_type;

        let _orderStartDate = '';
        let _orderEndDate = '';

        if (_orderDateRangeType === '' || _orderDateRangeType === dateRangePresets.CUSTOM) {
          // No action needed for empty or custom date range type
        } else {
          const date = dateRangePresetsValues(_orderDateRangeType);
          const [start, end] = date;

          _orderStartDate = start;
          _orderEndDate = end;
          filterValue.startDate = _orderStartDate;
          filterValue.endDate = _orderEndDate;
        }

        filterValue.orderDateRangeType = _orderDateRangeType;

        return filterValue;
      };

      const tempFilterValues = filterValues(selectedFilterViewFromURL);

      setSelectedFilterView(currentSelectedView);
      if (isUpdateFilterSate) {
        setCurrentlyAppliedFilters(appliedFiltersFromURL);

        setSelectedEmails([user?.email]);

        setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
        setLimit(tempFilterValues.limit || limit);
        setSelectedTenant(tempFilterValues.tenant);
        setDestinationTenantId(tempFilterValues.destination_tenant_id);
        setSelectedStatus(tempFilterValues.status);
        setPaymentStatus(tempFilterValues.payment_status);
        setSelectedReceivingStatus(tempFilterValues.po_receiving_status);
        setSearchKeyword(tempFilterValues.keyword);
        setKeyword(tempFilterValues.keyword);
        setStartDate(tempFilterValues.startDate);
        setEndDate(tempFilterValues.endDate);
        setOrderDateSelectedIntervalDateRangeType(tempFilterValues.orderDateRangeType);
        setExpiryTime(tempFilterValues.exp_time_range);
        setSelectedDepartment(tempFilterValues.department_ids);
        setSelectedProductFromPR(tempFilterValues.product_search_from_pr);
        setEstimatedDeliveryDate(tempFilterValues.edd ? tempFilterValues.edd : null);
        setSelectedTag(tempFilterValues.label);
        // setSearchByProduct(tempFilterValues.product_search);
        // setSelectedProductId(tempFilterValues.product_search);
        setExpiryStartDate(tempFilterValues.expiry_start_date);
        setExpiryEndDate(tempFilterValues.expiry_end_date);
      }

      if (!isUserReady) setIsUserReady(true);
      if (!isUpdateFilterSate) setIsUpdateFilterSate(true);
    }
  }, [savedFilterViews, isUserReadyInitial]);

  const downloadHandler = () => {
    const visibleColumnKeys = Object.entries(visibleColumns)
      .filter(([key, value]) => value.visible)
      .map(([key]) => key.toLowerCase())
      .join(',');
    const numbersArray = [];
    const stringsArray = [];
    const emailsArray = selectedEmails;
    const dataList = visibleColumnKeys.split(',');
    dataList.forEach((item) => {
      if (!isNaN(item)) {
        numbersArray.push(Number(item));
      } else {
        stringsArray.push(item);
      }
    });

    const numbersString = numbersArray.join(',');
    const stringsString = stringsArray.join(',');
    const emailsString = emailsArray.join(',');
    const payload = {
      org_id: user?.tenant_info?.org_id,
      page: Helpers.getValueFromUrl('page'),
      limit: Helpers.getValueFromUrl('limit'),
      tenant_id: selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.READ)?.join(','),
      search_keyword: Helpers.getValueFromUrl('keyword'),
      status: Helpers.getValueFromUrl('status'),
      po_receiving_status: Helpers.getValueFromUrl('po_receiving_status'),
      from_date: Helpers.getValueFromUrl('startDate'),
      to_date: Helpers.getValueFromUrl('endDate'),
      expiry_start_date: Helpers.getValueFromUrl('expiry_start_date') ? dayjs(Number(Helpers.getValueFromUrl('expiry_start_date'))).format('YYYY-MM-DD') : '',
      expiry_end_date: Helpers.getValueFromUrl('expiry_end_date') ? dayjs(Number(Helpers.getValueFromUrl('expiry_end_date'))).format('YYYY-MM-DD') : '',
      columns: stringsString,
      custom_fields: numbersString,
      no_wait: true,
      emails: emailsString,
      type: 'send_email',
      level: reportType,
      edd: Helpers.getValueFromUrl('edd'),
      user_id: user?.user_id,
    };
    if (!getDownloadPOLoading) {
      downloadPOData(payload, () => {
        setOpenPopover(false);
      });
    }
  };

  useEffect(() => {
    if (isUserReady) {
      pushParamsToUrl(currentPage, limit, selectedTenant, selectedStatus, selectedReceivingStatus, searchKeyword, expiryStartDate, expiryEndDate, expiryTime, startDate, endDate, paymentStatus, estimatedDeliveryDate, selectedProductId, selectedTag, selectedDepartment, selectedProductFromPR, destinationTenantId, orderDateSelectedIntervalDateRangeType, selectedFilterView);
      const payload = {
        orgId: user?.tenant_info?.org_id,
        entityName: 'PURCHASE_ORDERS',
      };
      setCurrentlyAppliedFilters(getAppliedFiltersFromURL());

      getDocCFV2(payload);
      // getPurchaseOrders(
      //   user?.tenant_info?.org_id,
      //   selectedTenant?.filter(
      //     (item) => !isNaN(item),
      //   )?.length > 0 ? selectedTenant?.join(',')
      //     : Helpers.getTenantEntityPermission(
      //       user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ,
      //     )?.join(','), null, null, null, Helpers.getValueFromUrl('startDate'), Helpers.getValueFromUrl('endDate'),
      //   Helpers.getValueFromUrl('status'), Helpers.getValueFromUrl('page'), Helpers.getValueFromUrl('limit'), null, null, null, Helpers.getValueFromUrl('keyword'), Helpers.getValueFromUrl('po_receiving_status'), Helpers.getValueFromUrl('expiry_start_date') ? dayjs(Number(Helpers.getValueFromUrl('expiry_start_date'))).format('YYYY-MM-DD') : '', Helpers.getValueFromUrl('expiry_end_date') ? dayjs(Number(Helpers.getValueFromUrl('expiry_end_date'))).format('YYYY-MM-DD') : '', Helpers.getValueFromUrl('payment_status'),
      //   (Helpers.getValueFromUrl('edd')), (Helpers.getValueFromUrl('product_search') || Helpers.getValueFromUrl('product_search_from_pr')), null, Helpers.getValueFromUrl('label'), Helpers.getValueFromUrl('department_ids'), '', Helpers.getValueFromUrl('destination_tenant_id'), true,
      // );
      const POListPayload = {
        org_id: user?.tenant_info?.org_id,
        tenant_id: selectedTenant?.filter((item) => !isNaN(item))?.length > 0
          ? selectedTenant?.join(',')
          : Helpers.getTenantEntityPermission(
            user?.user_tenants,
            Helpers.permissionEntities.PURCHASE_ORDER,
            Helpers.permissionTypes.READ,
          )?.join(','),
        from_date: Helpers.getValueFromUrl('startDate'),
        to_date: Helpers.getValueFromUrl('endDate'),
        status: Helpers.getValueFromUrl('status'),
        page: Helpers.getValueFromUrl('page'),
        limit: Helpers.getValueFromUrl('limit'),
        search_keyword: Helpers.getValueFromUrl('keyword'),
        po_receiving_status: Helpers.getValueFromUrl('po_receiving_status'),
        expiry_start_date: Helpers.getValueFromUrl('expiry_start_date')
          ? dayjs(Number(Helpers.getValueFromUrl('expiry_start_date'))).format('YYYY-MM-DD')
          : '',
        expiry_end_date: Helpers.getValueFromUrl('expiry_end_date')
          ? dayjs(Number(Helpers.getValueFromUrl('expiry_end_date'))).format('YYYY-MM-DD')
          : '',
        payment_status: Helpers.getValueFromUrl('payment_status'),
        edd: Helpers.getValueFromUrl('edd'),
        product_sku_ids: Helpers.getValueFromUrl('product_search') || Helpers.getValueFromUrl('product_search_from_pr'),
        tags: Helpers.getValueFromUrl('label'),
        department_ids: Helpers.getValueFromUrl('department_ids'),
        destination_tenant_id: Helpers.getValueFromUrl('destination_tenant_id'),
        is_list: true,
      };

      getPurchaseOrdersV2({
        query: POListPayload,
      });
    }
  }, [selectedStatus, selectedReceivingStatus, selectedTenant, searchKeyword, currentPage, limit, expiryStartDate, expiryEndDate, expiryTime, startDate, endDate, paymentStatus, estimatedDeliveryDate, selectedProductId, selectedTag, selectedDepartment, selectedProductFromPR, destinationTenantId, call, orderDateSelectedIntervalDateRangeType,
    // selectedFilterView
  ]);

  const now = dayjs();
  function getExpiryStatus(expiryDate) {
    const today = dayjs().startOf('day');
    const expiry = dayjs(expiryDate).startOf('day');
    const daysDifference = Number(expiry.diff(today, 'day'));

    if (daysDifference > 7) {
      const weeks = Math.floor(daysDifference / 7);
      return `Expires in ${weeks} week${weeks > 1 ? 's' : ''}`;
    }

    if (daysDifference > 2) {
      return `Expires in ${daysDifference} day${daysDifference > 1 ? 's' : ''}`;
    }

    if (daysDifference === 2) {
      return 'Expires in 2 days';
    }

    if (daysDifference === 1) {
      return 'Expires Tomorrow';
    }

    if (daysDifference === 0) {
      return 'Expires Today';
    }

    if (daysDifference === -1) {
      return 'Expired Yesterday';
    }

    if (daysDifference === -2) {
      return 'Expired 2 days ago';
    }

    if (daysDifference >= -7) {
      const weeks = Math.abs(Math.floor(daysDifference / 7));
      return `Expired ${weeks} week${weeks > 1 ? 's' : ''} ago`;
    }

    const months = Math.abs(Math.floor(daysDifference / 30));
    return `Expired ${months} month${months > 1 ? 's' : ''} ago`;
  }

  /**
  *
  * @return {[{width: string, title: string, render: (function(*, *): JSX.Element)},{width: string, title: string, render: (function(*, *))}]}
  */
  const addEmails = (value) => { setSelectedEmails(value); };

  const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

  const getProductColumns = () => {
    const productListColumns = [
      // {
      //   title: '',
      //   render: (record) => (
      //     <Link to={`/approval?type=po&id=${record.po_id}`}>
      //       <div className="mobile-list__item">
      //         <div style={{ display: 'flex' }}>
      //           <H3Text text={`#${record?.po_number}`} className="mobile-list__item-number" />
      //           <div className="mobile-list__item-status" style={{ backgroundColor: Helpers.getStatusColor(record.status).color }}>
      //             {Helpers.getStatusColor(record.status).text?.toUpperCase()}
      //           </div>
      //         </div>
      //         {record?.seller_info && (
      //           <div className="mobile-list__item-info">
      //             {`Vendor - ${record.seller_info?.seller_name}`}
      //           </div>
      //         )}
      //         <H3Text text={`Amount - ${MONEY((record?.po_grand_total || '0'), record?.org_currency_info?.currency_code)}`} className="mobile-list__item-info" />
      //         <H3Text
      //           text={(
      //             <React.Fragment>
      //               Receiving Status -&nbsp;
      //               <span style={{ color: Helpers.getStatusColor(record?.po_receiving_status || 'NOT_RECEIVED').color }}>
      //                 {Helpers.getStatusColor(record?.po_receiving_status || 'NOT_RECEIVED').text?.toUpperCase()}
      //               </span>
      //             </React.Fragment>
      //           )}
      //           className="mobile-list__item-info"
      //         />
      //         <H3Text text={`Created by ${(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} on ${toISTDate(record?.created_at).format('DD/MM/YYYY')}`} className="mobile-list__item-footer" />
      //       </div>
      //     </Link>
      //   ),
      //   responsive: ['xs'],
      // },
      {
        title: '',
        render: (record) => {
          return (
            <div className="mobile-list__card">
              <div className="mobile-list__card_header">
                <div className="mobile-list__card_header-left">
                  <PRZText className="mobile-list__card_item-number" text={`#${record?.po_number ? record.po_number : 'N/A'}`} />
                </div>
                <div className="mobile-list__card_header-right">
                  <PRZText
                    style={{ backgroundColor: Helpers.getStatusColor(record.status).color }}
                    text={Helpers.getStatusColor(record.status).text?.toUpperCase()}
                    className="mobile-list__card__status"
                  />
                </div>
              </div>
              <div className="mobile-list__card_body">
                <div className="mobile-list__card_body-left">
                  <div className="mobile-list__card_item-name_wrapper">
                    <Link to={`/vendors/view/${record?.seller_info?.seller_id}`} target="_blank">
                      <PRZText
                        className="mobile-list__card_item-name"
                        text={(record && record.seller_info) ? `${record?.seller_info?.internal_slr_code ? `${record?.seller_info?.internal_slr_code} - ` : ''}${record.seller_info?.seller_name}`?.trim() : ''}
                      />
                    </Link>
                  </div>
                  <PRZText
                    text={`Location - ${record?.tenant_info?.tenant_name} (${record?.tenant_department_info?.department_name || 'N/A'})`}
                    className="mobile-list__card_item-details"
                  />
                  <PRZText
                    text={`PO Date - ${toISTDate(record?.po_date).format('DD/MM/YYYY')}`}
                    className="mobile-list__card_item-details"
                  />
                  <PRZText
                    text={`PO Type - ${record?.purchase_order_without_costing ? 'BLANKET ORDER' : record?.po_type?.replaceAll('_', ' ')}`}
                    className="mobile-list__card_item-details"
                  />
                </div>
                <div className="mobile-list__card_body-right">
                  <Tooltip
                    color="white"
                    placement="top"
                    title={(
                      <PRZText className="mobile-list__card_item__tooltip_text-color" text="Amount" />
                    )}
                  >
                    <PRZText
                      text={(isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage="You don't have access to view amount" /> : MONEY((record.po_grand_total || '0'), record?.org_currency_info?.currency_code)}
                    />
                  </Tooltip>
                </div>
              </div>
              <Divider className="mobile-list__card_divider" />
              <div className="mobile-list__card_footer">
                <div className="mobile-list__card_footer-left">
                  <Tooltip
                    title={(
                      <PRZText
                        className="mobile-list__card_item__tooltip_text-color mobile-list__card_item__category__tooltip"
                        text="Expiry Status"
                      />
                    )}
                    color="white"
                  >
                    <div>
                      {record?.po_expiry_date != null ? (
                        <Tag icon={<ExclamationCircleOutlined />} color={getExpiryStatus(record?.po_expiry_date)?.includes('Expires Today') ? 'warning' : getExpiryStatus(record?.po_expiry_date)?.includes('Expired') ? 'error' : 'green'}>
                          {getExpiryStatus(record?.po_expiry_date)}
                        </Tag>
                      ) : '-'}
                    </div>
                  </Tooltip>
                  <div className="mobile-list__card_footer__actions-button_wrapper">

                    {user?.tenant_info?.zoho_branch_id
                      && user?.user_tenants?.find((item) => item?.tenant_id === record?.tenant_id)?.zoho_branch_id && record?.status === 'ISSUED' && (
                        <div className="card_footer__actions-button">
                          {(record?.zoho_po_id)
                            ? (
                              <Tooltip
                                title={toISTDate(record?.zoho_updated_at).format('DD/MM/YYYY hh:mm A')}
                                overlayClassName="font-12"
                                placement="topRight"
                              >
                                <a
                                  href={`https://books.zoho.in/app#/purchaseorders/${record?.zoho_po_id}`}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <div className="img-zoho__wrapper card_footer__actions-button_image__wrapper">
                                    <img
                                      style={{
                                        width: '18px',
                                        height: '18px',
                                      }}
                                      src={ZohoBooks}
                                      alt="Zoho"
                                      className="img-zoho card_footer__actions-button_image"
                                    />
                                    <div className="green-indicator" />
                                  </div>
                                </a>
                              </Tooltip>
                            ) : !['SENT_FOR_APPROVAL', 'DRAFT', 'VOID', 'CANCELLED'].includes(record?.status) && (
                              <Popconfirm
                                title={(record?.zoho_warning_message === null || record?.zoho_warning_message === '') ? 'This PO is not synced with Zoho Books.' : `${record?.zoho_warning_message}`}
                                onConfirm={() => syncPO(
                                  { po_id: record?.po_id },
                                  () => setCall(!call))}
                                okText="Sync again"
                                okButtonProps={{
                                  loading: syncPOLoading,
                                }}
                                cancelText="Cancel"
                              >
                                <div className="img-zoho__wrapper card_footer__actions-button_image__wrapper">
                                  <img
                                    style={{
                                      width: '18px',
                                      height: '18px',
                                    }}
                                    src={ZohoBooks}
                                    alt="Zoho"
                                    className="img-zoho img-zoho__disabled card_footer__actions-button_image"
                                  />
                                  <div className="green-indicator red-indicator" />
                                </div>
                              </Popconfirm>
                            )}
                        </div>
                      )}
                  </div>
                </div>
                <div className="mobile-list__card_footer-right">
                  <PRZText
                    className="mobile-list__card__view-more_wrapper"
                    onClick={() => {
                      setSelectedPO(record);
                      setMoreDetailsDrawer(true);
                    }}
                    text={(
                      <span className="mobile-list__card__view-more-text_wrapper">
                        <span className="mobile-list__card__view-more-text">More Info</span>
                        <FontAwesomeIcon
                          className="mobile-list__card__view-more-icon"
                          icon={faAnglesRight}
                        />
                      </span>
                    )}
                  />
                </div>
              </div>
            </div>
          );
        },
        // responsive: ['xs'],
        hidden: !isMobile,
      },
      {
        title: 'PO NUMBER',
        render: (record) => (
          <div className="min-width-70">
            {record?.po_number}
          </div>
        ),
        fixed: 'left',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.PO_NUMBER?.visible ? 'display-none' : '',
      },
      {
        title: 'PO TYPE',
        render: (record) => (
          <div className="min-width-70">
            <H3Text text={record?.purchase_order_without_costing ? 'BLANKET ORDER' : record?.po_type?.replaceAll('_', ' ')} />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.PO_TYPE?.visible ? 'display-none' : '',
      },
      {
        title: 'LOCATION',
        render: (record) => (
          <div className="min-width-70">
            <H3Text text={record?.tenant_info?.tenant_name} />
            <H3Text text={record?.tenant_department_info?.department_name} className="table-subscript" />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.LOCATION?.visible ? 'display-none' : '',
      },
      {
        title: 'VENDOR',
        render: (text, record) => (
          <div className="min-width-70">
            <div className="associated-entity">
              <Link to={`/vendors/view/${record?.seller_info?.seller_id}`} target="_blank">
                {(record && record.seller_info) ? `${record?.seller_info?.internal_slr_code ? `${record?.seller_info?.internal_slr_code} - ` : ''}${record.seller_info?.seller_name}`?.trim() : ''}
              </Link>
            </div>
            <div>
              {record?.seller_address?.city ? record.seller_address.city : ''}
            </div>
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.VENDOR?.visible ? 'display-none' : '',
      },
      {
        title: 'ITEMS',
        render: (text, record) => (
          <div className="min-width-50">
            {record.po_lines_count}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.ITEMS?.visible ? 'display-none' : '',
      },
      {
        title: 'AMOUNT WITHOUT TAX',
        render: (text, record) => (
          <div className="min-width-150">
            {(isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage="You don't have access to view amount" /> : MONEY((record.po_base_price || '0'), record?.org_currency_info?.currency_code)}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.AMOUNT_WITHOUT_TAX?.visible ? 'display-none' : '',
      },
      {
        title: 'TAXES',
        render: (text, record) => (
          <div className="min-width-50">
            {record?.seller_type === "OVERSEAS" ? "-" : MONEY((record.po_gst || '0'), record?.org_currency_info?.currency_code)}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.TAXES?.visible ? 'display-none' : '',
      },
      {
        title: 'AMOUNT',
        render: (text, record) => (
          <div className="min-width-70">
            {(isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage="You don't have access to view amount" /> : MONEY((record.po_grand_total || '0'), record?.org_currency_info?.currency_code)}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.AMOUNT_WITH_TAX?.visible ? 'display-none' : '',
      },
      {
        title: 'CREATED DATE',
        render: (text, record) => (
          <div className="min-width-100">
            <div className="column-date">
              {toISTDate(record?.created_at).format('DD/MM/YYYY')}
            </div>
            <H3Text text={(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} className="table-subscript" />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.CREATED_DATE?.visible ? 'display-none' : '',
      },
      {
        title: 'PO DATE',
        render: (text, record) => (
          <div className="column-date min-width-70">
            {toISTDate(record?.po_date).format('DD/MM/YYYY')}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.PO_DATE?.visible ? 'display-none' : '',
      },
      {
        title: 'PAYMENT TERMS',
        render: (text, record) => (
          <div className="min-width-115">
            {!record?.payment_terms?.[0]?.due_days ? 'On Delivery' : `${record?.payment_terms?.[0]?.due_days} Days Credit`}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.PAYMENT_TERMS?.visible ? 'display-none' : '',
      },
      {
        title: 'STATUS',
        render: (item) => (
          <div className="qr__status min-width-70" style={{ backgroundColor: Helpers.getStatusColor(item.status).color }}>
            {Helpers.getStatusColor(item.status).text}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.STATUS?.visible ? 'display-none' : '',
      },
      {
        title: 'EXPIRY STATUS',
        render: (item) => (

          <Tooltip
            title={toISTDate(item?.po_expiry_date).format('DD/MM/YYYY')}
            placement="topLeft"
            style={{ cursor: 'pointer' }}
          >
            <div className="min-width-85">
              {item?.po_expiry_date != null ? (
                <Tag icon={<ExclamationCircleOutlined />} color={getExpiryStatus(item?.po_expiry_date)?.includes('Expires Today') ? 'warning' : getExpiryStatus(item?.po_expiry_date)?.includes('Expired') ? 'error' : 'green'}>
                  {getExpiryStatus(item?.po_expiry_date)}
                </Tag>
              ) : '-'}
            </div>
          </Tooltip>

        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.EXPIRY_STATUS?.visible ? 'display-none' : '',
      },
      {
        title: 'RECEIVING STATUS',
        render: (item) => (
          <div className="min-width-115">
            <div style={{ color: Helpers.getStatusColor(item?.po_receiving_status || 'NOT_RECEIVED').color }}>
              {Helpers.getStatusColor(item?.po_receiving_status || 'NOT_RECEIVED').text?.toUpperCase()}
            </div>
            {item?.closing_status === 'CLOSED' && (
              <div className="po-short-closed-tag">
                Closed
              </div>
            )}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.RECEIVING_STATUS?.visible ? 'display-none' : '',
      },
      {
        title: 'PAYMENT STATUS',
        render: (item) => (
          <div
            style={{
              color: Helpers.getStatusColor(item?.payment_status).color,
            }}
            className="min-width-115"
          >
            {Helpers.getStatusColor(item?.payment_status).text?.toUpperCase()}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.PAYMENT_STATUS?.visible ? 'display-none' : '',
      },
      {
        title: 'LINKED MRP',
        render: (record) => (
          <div className="min-width-85">
            {record?.linked_mrps?.slice(0, 2)?.map((item) => (
              <div
                key={item?.mrp_id}
              >
                {/* <span>
                  {item?.mrp_name}
                </span> */}
                <Link to={`/production/planning/v2/view/${item?.mrp_id}`} target="_blank">
                  {' '}
                  {/* - */}
                  {' '}
                  {item?.mrp_number}
                </Link>
              </div>
            ))}
            {record?.linked_mrps?.length > 2 && (

              <Popover
                content={(
                  <div className="linked-doc__list__wrapper">
                    <div className="linked-doc__list-title">
                      Linked MRPs
                    </div>
                    {record?.linked_mrps?.slice(2)?.map((item) => (
                      <div
                        key={item?.mrp_id}

                      >
                        {/* <span>
                          {item?.mrp_name}
                        </span> */}
                        <Link
                          to={`/production/planning/view/v2/${item?.mrp_id}`}
                          target="_blank"
                          className="linked-doc__list-items"
                        >
                          {' '}
                          {/* - */}
                          {' '}
                          {item?.mrp_number}
                        </Link>
                      </div>
                    ))}
                  </div>
                )}
              >
                <div className="table-subscript" style={{ color: 'grey', cursor: 'pointer' }}>
                  {`and ${record.linked_mrps.length - 2} others`}
                </div>
              </Popover>
            )}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile || !user?.tenant_info?.production_config?.addons?.material_planing?.is_active,
        className: (!visibleColumns?.MRP_NUMBER?.visible) ? 'display-none' : '',
      },
      {
        title: 'LINKED MR',
        render: (item) => (
          <div className="min-width-70">
            {
              item?.pr_details?.map((row) => (
                <Link key={row?.pr_id} to={`/purchase/purchase-request/view/${row?.pr_id}`} target="_blank">
                  {row.pr_number}
                </Link>
              ))
            }
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.LINKED_PR?.visible ? 'display-none' : '',
      },
      {
        title: 'ATTACHMENTS',
        render: (text, record) => (
          <div className="min-width-100">
            {
              record?.attachments?.map((item, index) => (
                <div>
                  <a href={item?.url} target="_blank" rel="noreferrer">{`Link# ${index + 1}`}</a>
                </div>
              ))
            }
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.ATTACHMENTS?.visible ? 'display-none' : '',
      },
      {
        title: 'LABELS',
        render: (item) => (
          <div className="min-width-70">
            <div className="table-labels__list">
              <div>
                <Space size={[0, 8]} wrap>
                  {item?.tags?.map((tag, index) => (
                    <Tag
                      key={index}
                      color={colorArray[index]}
                    >
                      {tag}
                    </Tag>
                  ))}
                </Space>
              </div>
            </div>
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.LABEL?.visible ? 'display-none' : '',
      },
    ].filter((item) => item.hidden !== true);
    if (customFieldsProps?.data?.document_custom_fields?.length) {
      const customs = customFieldsProps?.data?.document_custom_fields;
      customs?.filter((item) => item?.is_active)?.map((custom) => {
        productListColumns.push({
          title: custom.field_name?.toUpperCase(),
          render: (record) => (
            <div className={Helpers.setColumnMinimumWidth(custom?.field_name)}>
              <ViewTableCustomFields customField={record.custom_fields?.filter((subItem) => subItem.cf_id === custom.cf_id)?.[0]} />
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
          hidden: isMobile,
          className: !visibleColumns?.[custom.cf_id]?.visible ? 'display-none' : '',
        });
      });
    }
    productListColumns.push({
      title: '',
      key: 'action',
      render: (text, record) => (
        <div className="list__actions">
          {user?.tenant_info?.zoho_branch_id
            && user?.user_tenants?.find((item) => item?.tenant_id === record?.tenant_id)?.zoho_branch_id && record?.status === 'ISSUED' && (
              <div className="list__actions-button">
                {(record?.zoho_po_id)
                  ? (
                    <Tooltip
                      title={toISTDate(record?.zoho_updated_at).format('DD/MM/YYYY hh:mm A')}
                      overlayClassName="font-12"
                      placement="topRight"
                    >
                      <a
                        href={`https://books.zoho.in/app#/purchaseorders/${record?.zoho_po_id}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <div className="img-zoho__wrapper">
                          <img
                            src={ZohoBooks}
                            alt="Zoho"
                            className="img-zoho"
                          />
                          <div className="green-indicator" />
                        </div>
                      </a>
                    </Tooltip>
                  ) : !['SENT_FOR_APPROVAL', 'DRAFT', 'VOID', 'CANCELLED'].includes(record?.status) && (
                    <Popconfirm
                      placement="topRight"
                      title={(record?.zoho_warning_message === null || record?.zoho_warning_message === '') ? 'This PO is not synced with Zoho Books.' : `${record?.zoho_warning_message}`}
                      onConfirm={() => syncPO(
                        { po_id: record?.po_id },
                        () => setCall(!call))}
                      okText="Sync again"
                      okButtonProps={{
                        loading: syncPOLoading,
                      }}
                      cancelText="Cancel"
                    >
                      <div className="img-zoho__wrapper">
                        <img
                          src={ZohoBooks}
                          alt="Zoho"
                          className="img-zoho img-zoho__disabled"
                        />
                        <div className="green-indicator red-indicator" />
                      </div>
                    </Popconfirm>
                  )}
              </div>
            )}
          {!isPortrait && (
            <Link to={`/approval?type=po&id=${record.po_id}`}>
              <div className=" list__actions-button">
                View
              </div>
            </Link>
          )}
          <Dropdown
            trigger={['click']}
            placement="bottomLeft"
            overlay={
              (<Menu>
                <SubMenu title={`Purchase Order (${record?.org_currency_info?.currency_code})`}>
                  <Menu.Item
                    key="po-pdf"
                    onClick={() => {
                      if (['ISSUED'].includes(record.status)) {
                        downloadDocument({
                          url: `${Constants.PURCHASE_ORDERS}/download?po_id=${record?.po_id}&tenant_id=${record?.tenant_id}&download_document_in_base_currency=false`,
                          document_type: 'PURCHASE_ORDER',
                          document_number: record?.po_number,
                          key: uuidv4(),
                        });
                      }
                    }}
                  >
                    Download PDF
                  </Menu.Item>
                  <Menu.Item
                    key="po-excel"
                    onClick={() => {
                      if (['ISSUED'].includes(record.status)) {
                        downloadDocument({
                          url: `${Constants.PURCHASE_ORDERS}/download/excel?po_id=${record?.po_id}&tenant_id=${record?.tenant_id}&download_document_in_base_currency=false`,
                          document_type: 'PURCHASE_ORDER',
                          document_number: record?.po_number,
                          key: uuidv4(),
                        });
                      }
                    }}
                  >
                    Download Excel
                  </Menu.Item>
                </SubMenu>
              </Menu>)
            }
          >
            <div className="list__actions-button list__actions-button-download">
              <div
                className={`${
                  !['ISSUED'].includes(record.status)
                    ? 'list__actions-button-download-disabled'
                    : ''
                }`}
                style={{ marginLeft: '5px', marginRight: '5px' }}
              >
                <H3Text
                  text={<FontAwesomeIcon icon={faDownload} />}
                  className="action-button"
                />
              </div>
            </div>
          </Dropdown>
          {!isPortrait && Helpers.getPermission(Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.CREATE, user) && (
            <Tooltip
              placement="topLeft"
              title="Make a Copy"
            >
              <div className=" list__actions-button">
                <CopyOutlined
                  style={{
                    fontSize: '16px',
                  }}
                  onClick={() => {
                    history.push({
                      pathname: '/purchase/purchase-orders/create',
                      state: {
                        clonePoId: record?.po_id,
                        selectedTenantId: record?.tenant_id,
                      },
                    });
                  }}
                />
              </div>
            </Tooltip>
          )}
        </div>
      ),
      fixed: 'right',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      hidden: isMobile,
      className: 'list__actions-column',
    });
    return productListColumns.filter((item) => !item.hidden);
  };

  useEffect(() => {
    if (customFieldsProps?.data?.document_custom_fields?.length) {
      const customFields = customFieldsProps?.data?.document_custom_fields;
      const columns = JSON.parse(JSON.stringify(visibleColumns));
      customFields?.filter((item) => item?.is_active)?.map((customField) => {
        columns[customField.cf_id] = {
          label: customField?.field_name,
          visible: JSON.parse(localStorage.getItem('prcz-page-columns-po'))?.[customField.cf_id]?.visible || false,
        };
      });
      setVisibleColumns(columns);
    }
  }, [customFieldsProps]);

  const handleChange = (value, option) => {
    setSelectedProductId(value);
    setSelectedProducts(option);
  };
  const allTenants = Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ);

  const purchaseOrderStatusOptions = [
    { key: '', value: '', label: 'All Purchase Orders' },
    { key: 'DRAFT', value: 'DRAFT', label: 'Draft' },
    { key: 'SENT_FOR_APPROVAL', value: 'SENT_FOR_APPROVAL', label: 'Sent For Approval' },
    { key: 'ISSUED', value: 'ISSUED', label: 'Issued' },
    { key: 'CANCELLED', value: 'CANCELLED', label: 'Cancelled' },
  ];

  const receivedStatusOptions = [
    { key: 'RECEIVED', value: 'RECEIVED', label: 'Received' },
    { key: 'PARTIALLY_RECEIVED', value: 'PARTIALLY_RECEIVED', label: 'Partially Received' },
    { key: 'NOT_RECEIVED', value: 'NOT_RECEIVED', label: 'Not Received' },
    { key: 'RECEIVED_MORE', value: 'RECEIVED_MORE', label: 'Received More' },
  ];

  const paymentStatusOptions = [
    { key: 'PAID_MORE', value: 'PAID_MORE', label: 'Paid More' },
    { key: 'PARTIALLY_PAID', value: 'PARTIALLY_PAID', label: 'Partially Paid' },
    { key: 'PAID', value: 'PAID', label: 'Paid' },
    { key: 'NOT_PAID', value: 'NOT_PAID', label: 'Not Paid' },
  ];

  return (
    <Fragment>
      <Drawer
        open={moreDetailsDrawer}
        mask
        onClose={() => setMoreDetailsDrawer(false)}
        destroyOnClose
        rootClassName="mobile__more-details_wrapper"
      >
        <div className="custom-drawer__header-wrapper">
          <div
            className="custom-drawer__header"
          >
            <H3Text
              text={`${selectedPO?.po_number}`}
              className="custom-drawer__title"
            />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => setMoreDetailsDrawer(false)}
            />
          </div>
        </div>
        <MoreInfoMobileView
          customFields={selectedPO?.custom_fields}
          fields={ListScreenKeys({ documentData: selectedPO, MONEY, priceMasking })}
        />
      </Drawer>
      <Drawer
        open={showFilters}
        onClose={() => setShowFilters(false)}
        showHeader
        width="360px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '310px' }}>
            <H3Text text="Apply Filters" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowFilters(false)} />
          </div>
        </div>
        <div className="po-filters__wrapper">
          <div className="filter__container">
            <div className="filter__title">Business Unit</div>
            <TenantSelector
              selectedTenant={selectedTenant}
              showSearch
              onChange={(value) => {
                setSelectedTenant(value);
              }}
              placeholder="Select Business Unit"
              isMultiple
              hideTitle
              includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ)}
            />
          </div>
          <div className="filter__container">
            <div className="filter__title">Destination Business Unit</div>
            <TenantSelector
              selectedTenant={destinationTenantId}
              showSearch
              onChange={(value) => {
                setDestinationTenantId(value);
              }}
              placeholder="Select Business Unit"
              isMultiple
              hideTitle
              includedTenants={allTenants?.filter((item) => item !== user?.tenant_info?.tenant_id)}
            />
          </div>
          <div className="filter__container">
            <div className="filter__title">Departments</div>
            <SelectDepartment
              title="Select Department"
              hideTitle
              selectedDepartment={selectedDepartment}
              noDropdownAlign
              onChange={(value) => {
                setSelectedDepartment(value);
              }}
              isMultiple
            />
          </div>
          <div className="filter__container">
            <div className="filter__title">Status</div>
            <PRZSelect
              dropdownAlign={{ offset: [3, 4] }}
              value={selectedStatus}
              onChange={(value) => {
                setSelectedStatus(value);
                setCurrentPage(1);
              }}
              placeholder="Search by Status.."
              className="purchase-orders__table-header__filter"
              options={purchaseOrderStatusOptions}
            />
          </div>
          <div className="filter__container">
            <div className="filter__title">Receiving Status</div>
            <PRZSelect
              mode="multiple"
              maxTagCount="responsive"
              dropdownAlign={{ offset: [3, 4] }}
              value={selectedReceivingStatus}
              onChange={(value) => {
                const statusArr = [];
                for (let i = 0; i < value?.length; i++) {
                  statusArr.push(value[i]);
                }
                setSelectedReceivingStatus(statusArr);
                setCurrentPage(1);
              }}
              placeholder="Search by Recieving Status.."
              className="purchase-orders__table-header__filter"
              options={receivedStatusOptions}
            />
          </div>
          <div className="filter__container">
            <div className="filter__title">Expiry Status</div>
            <PRZSelect
              placeholder="Select Expiry Status.."
              value={expiryTime}
              onChange={(value) => {
                const dates = value.split(',');
                setExpiryStartDate(dates[0]);
                setExpiryEndDate(dates[1]);
                setCurrentPage(1);
                const selectedPeriod = timePeriods.find((period) => period.value === value);
                const selectedLabel = selectedPeriod ? selectedPeriod.label : '';
                setExpiryTime(selectedLabel);
              }}
              options={timePeriodOptions}
            />
          </div>
          <div className="filter__container">
            <div className="filter__title">Payment Status</div>
            <PRZSelect
              dropdownAlign={{ offset: [3, 4] }}
              value={paymentStatus}
              onChange={(value) => {
                setPaymentStatus(value);
                setCurrentPage(1);
              }}
              placeholder="Search by Payment Status.."
              className="purchase-orders__table-header__filter"
              options={paymentStatusOptions}
            />
          </div>
          <div className="filter__container">
            <div className="filter__title">Estimated Delivery Date</div>
            <DatePicker
              value={estimatedDeliveryDate ? dayjs(estimatedDeliveryDate) : ''}
              onChange={(value) => {
                setEstimatedDeliveryDate(dayjs(value).format('YYYY-MM-DD'));
                setSelectedStatus('ISSUED');
                setCurrentPage(1);
              }}
              style={{
                width: '100%',
                borderRadius: '3px',
                height: '28px',
                border: '1px solid rgba(68, 130, 218, 0.2)',
              }}
            />
          </div>
          <div className="filter__container">
            <div className="filter__title"> Select Labels </div>
            <div className="sales-orders__header__section-status">
              <TagSelector
                filter
                entityType="PURCHASE_ORDER"
                selectedTags={selectedTag}
                showSearch
                showAll={false}
                noDropdownAlign
                isMultiple
                onChange={(value) => {
                  setCurrentPage(1);
                  setSelectedTag(value);
                }}
                placeholder="Select Label"
                hideTitle
                hideCSS
              />
            </div>
          </div>
        </div>
      </Drawer>
      <Drawer
        placement="right"
        onClose={() => { setShowBulkImportDrawer(false); }}
        open={showBulkImportDrawer}
        width="1045px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '1000px' }}>
            <H3Text
              text="Import Purchase Orders"
              className="custom-drawer__title"
            />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => setShowBulkImportDrawer(false)}
            />
          </div>
        </div>
        <BulkImportPO />
      </Drawer>
      <Modal
        title={(
          <div className="search-by-product-modal">
            <img
              alt="shopify icon"
              src={searchIcon} // Make sure 'searchIcon' is defined and imported
              width={20}
              height={20}
              style={{ marginRight: 10 }}
            />
            <div>Search By Product Name</div>
            &nbsp;  &nbsp;
            {getProductsLoading && <Spin size="small" />}
          </div>
        )}
        getContainer={() => document.querySelector('.trigger-modal-btn')}
        style={{
          top: '17px',
          left: isMobileOrPortrait ? '-1%' : '6%',
          width: '520px',
        }}
        open={isModalOpen}
        onOk={() => {
          setIsModalOpen(false);
        }}
        onCancel={() => {
          setIsModalOpen(false);
        }}
        footer={null}
        mask
        maskClosable
        closeIcon={null}
      >
        <div className="section-search">
          <div className="section-search-bar__wrapper" style={{ width: '100%' }}>
            <PRZSelect
              showSearch
              mode="multiple"
              style={{ width: '100%' }}
              placeholder="Select a product"
              optionFilterProp="children"
              onSearch={(value) => setSearchByProduct(value)}
              value={selectedProductId}
              onChange={handleChange}
              loading={getProductsLoading}
              filterOption={(input, option) => option?.children?.toLowerCase()?.indexOf(input.toLowerCase()) >= 0}
            >
              {products?.result?.products?.map((product) => (
                <Option key={product.product_sku_id} value={product.product_sku_id}>
                  {product?.product_info?.product_sku_name}
                </Option>
              ))}
            </PRZSelect>
          </div>
        </div>
      </Modal>
      <div className="doc-list__wrapper">
        <div className="ant-row">
          <div className="ant-col-md-24 ant-col-xs-24">
            <div className="doc-list__header-wrapper">
              <div className="doc-list__header-wrapper__left">
                <div className="section-search">
                  <div className="doc-list__search-bar__wrapper">
                    <div className="section-search-bar">
                      <input
                        value={keyword}
                        placeholder="Search for Purchase Order..."
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            setSearchKeyword(e.target.value);
                            setCurrentPage(1);
                          }
                        }}
                        onChange={(event) => {
                          setKeyword(event.target.value);
                        }}
                      />
                      <H3Image
                        src={searchIcon}
                        className="section-search-bar__icon"
                        alt="search"
                        onClick={() => {
                          setSearchKeyword(keyword);
                          setCurrentPage(1);
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="section-search">
                  <div className="search-by-product-modal-btn">
                    <H3Text
                      text={(
                        <div className="new-action-button-wrapper" onClick={() => setIsModalOpen(true)}>
                          <Fragment>
                            <div className="action-button-text">Search By Products </div>
                            <div className="action-button-text_mobile">Search</div>
                            &nbsp;  &nbsp;
                            <H3Image src={searchIcon} className="action-button-icon" />
                          </Fragment>
                        </div>
                      )}
                      className="action-button action-button-big"
                    />
                  </div>
                </div>
              </div>
              <div className="doc-list__header-wrapper__right">
                {Helpers.getPermission(Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.CREATE, user) && (
                  <div className="doc-list__buttons-wrapper">
                    <H3Button
                      buttonType={defaultButtonTypes.BLUE_ROUNDED}
                      text="+ New Purchase Order"
                      onClick={() => history.push('/purchase/purchase-orders/create')}
                      customClass="add-button"
                    />
                    <H3Button
                      buttonType={defaultButtonTypes.BLUE_ROUNDED}
                      text="+ Upload Purchase Orders"
                      onClick={() => { setShowBulkImportDrawer(true); }}
                      customClass="add-button"
                    />
                  </div>
                )}
              </div>

            </div>

            <div className="flex-align-c" style={{ gap: '10px' }}>
              <UserSavedFilterViewSelector
                selectedFilterView={selectedFilterView}
                onChangeTab={(currentSelectedView) => {
                  setSelectedFilterView(() => {
                    const currentSelectedViewFilters = currentSelectedView.filters;

                    const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: filterKey }) }), {});

                    const _orderDateRangeType = getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'startDate', valueOnly: false }).date_range_type;

                    let _orderStartDate = '';
                    let _orderEndDate = '';

                    if (_orderDateRangeType === '' || _orderDateRangeType === dateRangePresets.CUSTOM) {
                      // No action needed for empty or custom date range type
                    } else {
                      const date = dateRangePresetsValues(_orderDateRangeType);
                      const [start, end] = date;

                      _orderStartDate = start;
                      _orderEndDate = end;
                      filterValue.startDate = _orderStartDate;
                      filterValue.endDate = _orderEndDate;
                    }

                    filterValue.orderDateRangeType = _orderDateRangeType;

                    const tempFilterValues = filterValue;
                    setCurrentPage(1);
                    setLimit(tempFilterValues.limit || limit);
                    setSelectedTenant(tempFilterValues.tenant);
                    setDestinationTenantId(tempFilterValues.destination_tenant_id);
                    setSelectedStatus(tempFilterValues.status);
                    setPaymentStatus(tempFilterValues.payment_status);
                    setSelectedReceivingStatus(tempFilterValues.po_receiving_status);
                    setSearchKeyword(tempFilterValues.keyword);
                    setKeyword(tempFilterValues.keyword);
                    setStartDate(tempFilterValues.startDate);
                    setEndDate(tempFilterValues.endDate);
                    setOrderDateSelectedIntervalDateRangeType(tempFilterValues.orderDateRangeType);
                    setExpiryTime(tempFilterValues.exp_time_range);
                    setSelectedDepartment(tempFilterValues.department_ids);
                    setSelectedProductFromPR(tempFilterValues.product_search_from_pr);
                    setEstimatedDeliveryDate(tempFilterValues.edd ? tempFilterValues.edd : null);
                    setSelectedTag(tempFilterValues.label);
                    // setSearchByProduct(tempFilterValues.product_search);
                    // setSelectedProductId(tempFilterValues.product_search);
                    setExpiryStartDate(tempFilterValues.expiry_start_date);
                    setExpiryEndDate(tempFilterValues.expiry_end_date);

                    return currentSelectedView;
                  });
                }}
                currentlyAppliedFilters={currentlyAppliedFilters}
                entityName={entityNameEnum.PURCHASE_ORDER}
                setSavedFilterViews={(value) => setSavedFilterViews(value)}
                setSavedFilterViewsLoading={(value) => setSavedFilterViewsLoading(value)}
                setIsUpdateFilterSate={(value) => setIsUpdateFilterSate(value)}
                callback={() => {
                  if (!isUserReadyInitial) setIsUserReadyInitial(true);
                }}
                systemDefaultUserView={systemDefaultUserView}
              />
              <div className="header__tags">
                {searchKeyword && (
                  <Tag closable onClose={() => { setSearchKeyword(''); setKeyword(''); setCurrentPage(1); }} color="#2d7df7">
                    Search results for -
                    &nbsp;
                    <span><b><i>{searchKeyword}</i></b></span>
                  </Tag>
                )}

                {selectedTenant && selectedTenant?.map((item) => (
                  <Tag
                    key={item}
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setSelectedTenant(selectedTenant.filter((tId) => tId !== item));
                    }}
                    color="#2d7df7"
                  >
                    Business Unit -
                    &nbsp;
                    <span>
                      <b>{user?.user_tenants?.find((tenant) => tenant?.tenant_id == item)?.tenant_name?.toUpperCase()}</b>
                    </span>
                  </Tag>
                ))}
                {destinationTenantId && destinationTenantId?.map((item) => (
                  <Tag
                    key={item}
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setDestinationTenantId(destinationTenantId.filter((tId) => tId !== item));
                    }}
                    color="#2d7df7"
                  >
                    Destination Business Unit -
                    &nbsp;
                    <span>
                      <b>{user?.user_tenants?.find((tenant) => tenant?.tenant_id == item)?.tenant_name?.toUpperCase()}</b>
                    </span>
                  </Tag>
                ))}

                {selectedDepartment && selectedDepartment?.map((item) => (
                  <Tag
                    key={item}
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setSelectedDepartment(selectedDepartment.filter((tId) => tId !== item));
                    }}
                    color="#2d7df7"
                  >
                    Department -
                    &nbsp;
                    <span>
                      <b>{departments?.data?.result?.departments?.find((department) => department?.department_id == item)?.alias_name?.toUpperCase()}</b>
                    </span>
                  </Tag>
                ))}

                {selectedStatus && (
                  <Tag closable onClose={() => { setSelectedStatus(''); setCurrentPage(1); }} color="#2d7df7">
                    Status -
                    &nbsp;
                    <span><b>{selectedStatus?.split('_').join(' ').toUpperCase()}</b></span>
                  </Tag>
                )}
                {paymentStatus && (
                  <Tag closable onClose={() => { setPaymentStatus(''); setCurrentPage(1); }} color="#2d7df7">
                    Payment Status -
                    &nbsp;
                    <span><b>{paymentStatus?.split('_').join(' ').toUpperCase()}</b></span>
                  </Tag>
                )}
                {estimatedDeliveryDate && (
                  <Tag closable onClose={() => { setEstimatedDeliveryDate(''); setCurrentPage(1); }} color="#2d7df7">
                    Estimated Delivery Date -
                    &nbsp;
                    <span><b>{dayjs(estimatedDeliveryDate).format('YYYY-MM-DD')}</b></span>
                  </Tag>
                )}
                {selectedReceivingStatus && selectedReceivingStatus?.filter((i) => i)?.map((item) => (
                  <Tag
                    key={item}
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setSelectedReceivingStatus(selectedReceivingStatus.filter((tId) => tId !== item));
                    }}
                    color="#2d7df7"
                  >
                    Receiving Status -
                    &nbsp;
                    <span>
                      <b>{receivedStatus.find((status) => status == item)?.toUpperCase()?.replaceAll('_', ' ')}</b>
                    </span>
                  </Tag>
                ))}
                {
                  (startDate && endDate) ? (
                    <Tag
                      closable
                      onClose={() => {
                        setStartDate(null);
                        setEndDate(null);
                        setOrderDateSelectedIntervalDateRangeType('');
                      }}
                      color="#2d7df7"
                    >
                      {' '}
                      From:
                      &nbsp;
                      <span><b>{dayjs(startDate).format('DD/MM/YYYY')}</b></span>
                      &nbsp;
                      To:
                      &nbsp;
                      <span><b>{dayjs(endDate).format('DD/MM/YYYY')}</b></span>
                    </Tag>
                  ) : ''
                }
                {expiryTime && (expiryTime !== 'All Purchase Orders') && (
                  <Tag closable onClose={() => { setExpiryTime(''); setCurrentPage(1); setExpiryStartDate(''); setExpiryEndDate(''); }} color="#2d7df7">
                    Expiry Status -
                    &nbsp;
                    <span><b>{expiryTime}</b></span>
                  </Tag>
                )}
                {
                  selectedProductId?.length > 0 && selectedProductId?.map((item, index) => (
                    <Tag
                      key={index}
                      closable
                      onClose={() => {
                        setSelectedProductId(selectedProductId?.filter((id) => id !== item));
                      }}
                      color="#2d7df7"
                    >
                      {' '}
                      Product -
                      &nbsp;
                      <span><b>{selectedProducts?.find((product) => product.value === item)?.children}</b></span>
                    </Tag>
                  ))
                }
                {selectedTag && selectedTag?.map((item, index) => (
                  <Tag
                    key={index}
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setSelectedTag(selectedTag?.filter((tId) => tId !== item));
                    }}
                    color="#2d7df7"
                  >
                    Label -
                    &nbsp;
                    <span>
                      <b>{item?.toUpperCase()}</b>
                    </span>
                  </Tag>
                ))}
              </div>
            </div>
            <div className="doc-list__table-wrapper">
              <Table
                title={() => (
                  <div className="doc-list__table-header">
                    <div className="doc-list__table-header__left">
                      <H3Text text={`${(purchaseOrdersV2 && purchaseOrdersV2?.count) ? purchaseOrdersV2?.count : '0'} Purchase Orders`} className="purchase-orders__table-header" />
                    </div>
                    <div className="doc-list__table-header__right">
                      <div className="doc-list__filter-buttons">
                        {
                          purchaseOrdersV2 && purchaseOrdersV2?.count > 0
                          && (
                            <Popover
                              placement="bottom"
                              trigger="click"
                              title={<div className="download-btn-popover__title">Please provide your email address</div>}
                              open={openPopover}
                              onOpenChange={() => setOpenPopover(!openPopover)}
                              content={(
                                <React.Fragment>
                                  <div>
                                    <PRZSelect
                                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                      mode="tags"
                                      filterOption={false}
                                      value={selectedEmails}
                                      onChange={addEmails}
                                      disabled={getDownloadPOLoading}
                                      maxTagCount="responsive"
                                      style={{
                                        width: '300px',
                                        height: 'auto !important',
                                      }}
                                    >

                                      {selectedEmails.length > 0 ? (
                                        selectedEmails.map((item) => (
                                          <Option key={item} value={item}>
                                            {item}
                                          </Option>
                                        ))
                                      ) : (
                                        <Option key={user?.email} value={user?.email}>
                                          {user?.email}
                                        </Option>
                                      )}

                                    </PRZSelect>
                                  </div>
                                  <div className="mg-top-10">
                                    <Radio.Group onChange={(event) => setReportType(event?.target?.value)} disabled={getDownloadPOLoading} value={reportType}>
                                      <Space direction="vertical">
                                        <Radio key="1" value="document_level">Purchase Orders Data</Radio>
                                        <Radio key="2" value="line_level">Purchase Order Items Data</Radio>
                                      </Space>
                                    </Radio.Group>

                                  </div>
                                  <div className="mg-top-10">
                                    <H3Button
                                      text="Send"
                                      buttonType={defaultButtonTypes.BLUE_ROUNDED}
                                      onClick={() => { downloadHandler(); }}
                                      customClass="email-submit"
                                      isLoading={getDownloadPOLoading}
                                      disabled={getDownloadPOLoading}
                                    >
                                      Send

                                    </H3Button>
                                  </div>

                                </React.Fragment>
                              )}
                            >
                              <div
                                className={`download-btn ${getDownloadPOLoading ? 'download-btn__disabled' : ''}`}
                                onClick={() => {
                                  setOpenPopover(true);
                                }}
                              >
                                <H3Text
                                  text={(
                                    <FontAwesomeIcon icon={faDownload} />
                                  )}
                                  className="action-button"
                                />
                              </div>
                            </Popover>

                          )
                        }
                        <H3DateSelector
                          selectedInterval={orderDateSelectedIntervalDateRangeType}
                          startDate={startDate}
                          endDate={endDate}
                          onDateChangeWithDateRangeType={({ date, dateRangeType }) => {
                            setStartDate(dayjs(date[0])?.startOf('day').valueOf());
                            setEndDate(dayjs(date[1])?.endOf('day').valueOf());
                            setCurrentPage(1);
                            setOrderDateSelectedIntervalDateRangeType(dateRangeType);
                          }}
                        />
                        <div className="action-buttons">
                          <div className="action-button" onClick={() => setShowFilters(!showFilters)}>
                            <H3Text text="Filters" className="action-button-text" />
                            <FilterOutlined />
                          </div>
                        </div>
                        <Dropdown
                          overlay={(
                            <div className="custom-columns__content">
                              <div className="custom-columns__content-section">
                                <H3Text text="Visible Columns" className="custom-columns__content-title" />
                                {
                                  Object.keys(visibleColumns).filter((item) => visibleColumns[item]?.visible)?.map((key) => (
                                    <div key={key}>
                                      <Checkbox
                                        disabled={fixedColumns.includes(key)}
                                        checked={visibleColumns[key]?.visible}
                                        onChange={() => {
                                          const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                          visibleColumnsCopy[key].visible = !visibleColumns[key].visible;
                                          localStorage.setItem('prcz-page-columns-po', JSON.stringify(visibleColumnsCopy));
                                          setVisibleColumns(visibleColumnsCopy);
                                        }}
                                      >
                                        {visibleColumns[key]?.label}
                                      </Checkbox>
                                    </div>
                                  ))
                                }
                              </div>
                              {Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.length ? (
                                <div className="custom-columns__content-section">
                                  <H3Text text="Hidden Columns" className="custom-columns__content-title" />
                                  {
                                    Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.map((key) => (
                                      <div key={key}>
                                        <Checkbox
                                          disabled={fixedColumns.includes(key)}
                                          checked={visibleColumns[key]?.visible}
                                          onChange={() => {
                                            const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                            visibleColumnsCopy[key].visible = !visibleColumns[key].visible;
                                            localStorage.setItem('prcz-page-columns-po', JSON.stringify(visibleColumnsCopy));
                                            setVisibleColumns(visibleColumnsCopy);
                                          }}
                                        >
                                          {visibleColumns[key]?.label}
                                        </Checkbox>
                                      </div>
                                    ))
                                  }
                                </div>
                              ) : ''}
                            </div>
                          )}
                          trigger={['click']}
                          placement="bottomRight"
                        >
                          <div className="custom-columns__wrapper">
                            Customize Columns
                            <ControlOutlined />
                          </div>
                        </Dropdown>
                      </div>
                    </div>
                  </div>
                )}
                bordered
                loading={getPurchaseOrdersV2Loading || syncPOLoading || getDocCFV2Loading || savedFilterViewsLoading}
                showHeader
                size="small"
                scroll={!isMobileOrPortrait && purchaseOrdersV2 && !!purchaseOrdersV2.purchase_order?.length ? { x: 'max-content', y: 'calc(100dvh - 160px)' } : { x: 'max-content' }}
                // sticky={!isMobileOrPortrait && purchaseOrders && !!purchaseOrders.purchase_order?.length}
                columns={getProductColumns()}
                rowKey="po_id"
                dataSource={purchaseOrdersV2 && purchaseOrdersV2?.purchase_order ? purchaseOrdersV2?.purchase_order : []}
                pagination={
                  {
                    defaultCurrent: currentPage,
                    current: currentPage,
                    total: purchaseOrdersV2 ? purchaseOrdersV2?.count : 0,
                    pageSize: limit,
                    onChange: (page, pageSize) => {
                      setCurrentPage(page);
                      setLimit(pageSize);
                    },
                    position: ['bottomLeft'],
                    showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                    showSizeChanger: true,
                    pageSizeOptions: [10, 25, 50, 100],
                  }
                }
                rowClassName={(record) => (!record.is_active ? 'inactive_record' : '')}
              />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers, PurchaseOrderReducers, TenantReducers, GRNReducers, ZohoIntegrationReducers, CFV2Reducers, ProductReducers, DepartmentReducers, GetPurchaseOrders,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  tenants: TenantReducers.tenants,
  getTenantsLoading: TenantReducers.getTenantsLoading,
  grnData: PurchaseOrderReducers.grnData,
  getGRNLoading: GRNReducers.getGRNLoading,
  getPurchaseOrderByIdLoading: PurchaseOrderReducers.getPurchaseOrderByIdLoading,
  selectedPurchaseOrderProps: PurchaseOrderReducers.selectedPurchaseOrder,
  syncPOLoading: ZohoIntegrationReducers.syncPOLoading,
  getDocCFV2Loading: CFV2Reducers.getDocCFV2Loading,
  customFieldsProps: CFV2Reducers.cfV2DocPurchaseOrders,
  getDownloadPOLoading: PurchaseOrderReducers.getDownloadPOLoading,
  products: ProductReducers.products,
  getProductsLoading: ProductReducers.getProductsLoading,
  departments: DepartmentReducers.departments,
  priceMasking: UserReducers.priceMasking,
  purchaseOrdersV2: GetPurchaseOrders.data,
  getPurchaseOrdersV2Loading: GetPurchaseOrders.loading,
});

const mapDispatchToProps = (dispatch) => ({
  downloadPOData: (payload, callback) => dispatch(PurchaseOrderActions.downloadPOData(payload, callback)),
  getTenants: (page, keyword, isVerified, orgId) => dispatch(TenantActions.getTenants(page, keyword, isVerified, orgId)),
  getGRN: (page, poId) => dispatch(GRNActions.getGRN(page, poId)),
  getPurchaseOrderById: (poId) => dispatch(PurchaseOrderActions.getPurchaseOrderById(poId)),
  getPurchaseOrderByIdSuccess: (selectedPurchaseOrder) => dispatch(PurchaseOrderActions.getPurchaseOrderByIdSuccess(selectedPurchaseOrder)),
  syncPO: (payload, callback) => dispatch(ZohoIntegrationActions.syncPO(payload, callback)),
  getDocCFV2: (payload, callback) => dispatch(CFV2Actions.getDocCFV2(payload, callback)),
  getDocCFV2Success: (cf) => dispatch(CFV2Actions.getDocCFV2Success(cf)),
  getProducts: (keyword, tenantId, stockStatus, limit, page, tenantDepartmentId, excludeOutOfStock, productType, category, isSalesProduct, isPurchaseProduct, search, sortBy, filterReservedQuantity, barcode, isShopifyProduct, isMarketplaceProduct) => dispatch(ProductActions.getProducts(keyword, tenantId, stockStatus, limit, page, tenantDepartmentId, excludeOutOfStock, productType, category, isSalesProduct, isPurchaseProduct, search, sortBy, filterReservedQuantity, barcode, isShopifyProduct, isMarketplaceProduct)),
  downloadDocument: (payload, document) => dispatch(AnalyticsActions.downloadDocument(payload, document)),
  getPurchaseOrdersV2: (payload, callback) => dispatch(GetPurchaseOrders.actions.request(payload, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PurchaseOrdersList));
